import BossModel from "@/models/BossModel";
import Column from "@/models/PlatinumPage/Version/Element/Row/Column/Column";
import Element from "@/models/PlatinumPage/Version/Element/Element";

export default class Row extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-page/version/element/row';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumPageVersionElementRows';

    static fields() {
        return {
            id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            element: this.hasOne(Element, 'platinum_page_version_element_row_id'),
            columns: this.hasMany(Column, 'platinum_page_version_element_row_id'),
        }
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Columns() {
        return this.getRelated('columns');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Element() {
        return this.getRelated('element');
    }
}
